import { PUBLISH_FIXED_FEE, PUBLISH_SEAT_FEE, RESERVATION_FEE, DEV_MODE_FEE } from "./constants"

export interface FeeInfo {
  total: number
  display: string
  breakdown: string | null
}

export function getPublishFee(seats: number, isAdmin: boolean, devMode: boolean): FeeInfo {
  if (devMode && isAdmin) {
    return {
      total: DEV_MODE_FEE,
      display: `R$ ${DEV_MODE_FEE.toFixed(2).replace(".", ",")} (modo desenvolvedor)`,
      breakdown: null,
    }
  }
  const total = PUBLISH_FIXED_FEE + seats * PUBLISH_SEAT_FEE
  return {
    total,
    display: `R$ ${total.toFixed(0)}`,
    breakdown: `Taxa fixa: R$ ${PUBLISH_FIXED_FEE} + R$ ${PUBLISH_SEAT_FEE}/assento (${seats} assentos)`,
  }
}

export function getReservationFee(ridePrice: number, isAdmin: boolean, devMode: boolean): FeeInfo {
  if (devMode && isAdmin) {
    return {
      total: DEV_MODE_FEE,
      display: `R$ ${DEV_MODE_FEE.toFixed(2).replace(".", ",")} (modo desenvolvedor)`,
      breakdown: null,
    }
  }
  const total = ridePrice + RESERVATION_FEE
  return {
    total,
    display: `R$ ${total.toFixed(0)}`,
    // breakdown: `R$ ${ridePrice.toFixed(0)} +R$ ${RESERVATION_FEE} taxa de reserva`,
    breakdown: `+R$ ${RESERVATION_FEE} taxa de reserva`,
  }
}
